import {
    Divider,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    ListItemSecondaryAction,
    IconButton,
} from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { formatPriceByLocale, fullName } from '../../lib/utils';

type Inscription = {
    name?: string;
    surname?: string;
    price?: number;
    priceShape?: {
        currency?: string;
        locale?: string;
    };
};

type Props = {
    inscriptions: Inscription[];
    hidePrice?: boolean;
    onDelete: (inscription: Inscription) => void;
};

export function SttInscriptionList({
    inscriptions,
    hidePrice,
    onDelete,
}: Props): React.ReactElement {
    const { t } = useTranslation();

    // -----| Render |-----
    return (
        <List>
            {inscriptions &&
                inscriptions.map((inscription: any, i: any) => {
                    let price = '';
                    if (!hidePrice && inscription.price !== undefined) {
                        if (inscription.price > 0) {
                            price = formatPriceByLocale(
                                inscription.price,
                                inscription?.priceShape?.currency,
                                inscription?.priceShape?.locale,
                            );
                        } else {
                            price = t('payment.free');
                        }
                    }

                    return (
                        <div key={i}>
                            {i > 0 && <Divider />}
                            <ListItemButton>
                                <ListItemText
                                    primary={fullName(inscription)}
                                    secondary={price}
                                />
                                <ListItemSecondaryAction>
                                    <IconButton
                                        onClick={() => onDelete(inscription)}
                                        edge="end"
                                        aria-label="delete"
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </ListItemButton>
                        </div>
                    );
                })}
            {inscriptions && inscriptions.length === 0 && (
                <ListItem>
                    <ListItemText primary={t('common.none')} />
                </ListItem>
            )}
        </List>
    );
}
